import CashierServiceModel from "../CashierServiceModel";
import StockKeepingUnitCollection from "../../collections/cashier/StockKeepingUnitCollection";

export default class ProductModel extends CashierServiceModel {

  modelName() {
    return 'products';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    return routes;
  }

  defaults() {
    return {
      id: null,
      stripe_id: null,
      name: null,
      type: null,
      active: null,
      attrs: null,
      caption: null,
      description: null,
      images: null,
      metadata: null,
      package_dimensions: null,
      shippable: null,
      url: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      stripe_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      type: (val) => (this.nullStringMutator(val)),
      active: (val) => (this.nullStringMutator(val)),
      attrs: (val) => (this.nullStringMutator(val)),
      caption: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      images: (val) => (this.nullStringMutator(val)),
      metadata: (val) => (this.nullStringMutator(val)),
      package_dimensions: (val) => (this.nullStringMutator(val)),
      shippable: (val) => (this.nullStringMutator(val)),
      url: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getImage() {
    if(this.images && this.images.length && this.images[0]) {
      return this.images[0];
    }
    return null;
  }

  getStockKeepingUnits() {
    return this.getRelatedCollection(new StockKeepingUnitCollection(), 'stock_keeping_units');
  }

  currentStockKeepingUnit() {
    return this.getStockKeepingUnits().last();
  }

}
